const POST = "POST";
const UPDATE = "PUT";
const DELETE = "DELETE";
const GET = "GET";
const PATCH = "PATCH";

export { POST, UPDATE, DELETE, GET, PATCH };
